<template>
	<div class="cloud-Warning">

		<div class="cloud-Warning-title" style="width: 98%; height: 16.7vh; margin-top: 2vh;">
			<div class="cloud-Warning-title-title">
				<img src="@/assets/images/groupTitlec.png" alt="" />
				<p>当前报警检查情况</p>
				<dv-decoration-3 class="decoration-container" :style="{ width: '3%', height: '30px' }"
					style="position: absolute; top: 1px; margin-left: 96%;">
					<!-- 插槽中添加多个小方块 -->
					<div slot="content" class="squares-container">
						<div class="square s1"></div>
						<div class="square s2"></div>
						<div class="square s3"></div>
						<div class="square s4"></div>
						<div class="square s5"></div>
						<div class="square s6"></div>
					</div>
				</dv-decoration-3>
			</div>
			<div class="cloud-Warning-title-content" style="width: 100%; height: 11vh; overflow: hidden; ">
				<ul class="cloud-Warning-title-content-ul">
					<li>
						<img src="@/assets/images/warning_gas.png" alt="" />
						<div>
							<p>{{ WarningData?.gas }}</p>
							<p>环境预警</p>
						</div>
					</li>
					<li>
						<img src="@/assets/images/warning_person.png" alt="" />
						<div>
							<p>{{ WarningData?.worker }}</p>
							<p>人员预警</p>
						</div>
					</li>
					<li>
						<img src="@/assets/images/warning_car.png" alt="" />
						<div>
							<p>{{ WarningData?.car }}</p>
							<p>车辆预警</p>
						</div>
					</li>
					<li>
						<img src="@/assets/images/warning_step.png" alt="" />
						<div>
							<p>{{ WarningData?.environment }}</p>
							<p>步距预警</p>
						</div>
					</li>
				</ul>
			</div>
		</div>

		<div class="cloud-Warning-title" style="width: 98%; height: 27.7vh; margin-top: 1vh;">
			<div class="cloud-Warning-title-title">
				<img src="@/assets/images/groupTitlec.png" alt="" />
				<p>一周预警情况</p>
				<dv-decoration-3 class="decoration-container" :style="{ width: '3%', height: '30px' }"
					style="position: absolute; top: 1px; margin-left: 96%;">
					<!-- 插槽中添加多个小方块 -->
					<div slot="content" class="squares-container">
						<div class="square s1"></div>
						<div class="square s2"></div>
						<div class="square s3"></div>
						<div class="square s4"></div>
						<div class="square s5"></div>
						<div class="square s6"></div>
					</div>
				</dv-decoration-3>
			</div>
			<div class="cloud-Warning-title-content" style="width: 100%; height: 22vh; overflow: hidden;  ">
				<div id="main_Warning" style="width: 100%; height: 26vh; margin-top: 1vh; overflow: hidden;  "></div>
			</div>
		</div>

		<div class="cloud-Warning-title" style="width: 98%; height: 37.7vh; margin-top: 1vh;">
			<div class="cloud-Warning-title-title">
				<img src="@/assets/images/groupTitlec.png" alt="" />
				<p>当日检测报警查询</p>
				<dv-decoration-3 class="decoration-container" :style="{ width: '3%', height: '30px' }"
					style="position: absolute; top: 1px; margin-left: 96%;">
					<!-- 插槽中添加多个小方块 -->
					<div slot="content" class="squares-container">
						<div class="square s1"></div>
						<div class="square s2"></div>
						<div class="square s3"></div>
						<div class="square s4"></div>
						<div class="square s5"></div>
						<div class="square s6"></div>
					</div>
				</dv-decoration-3>
			</div>
			<div class="cloud-Warning-title-content" style="width: 100%; height: 33vh; overflow: hidden;  ">
				<ul class="cloud-Warning-title-content-table-ul">
					<li for="i" v-for="(item, index) in lastWarningData" :key="index" @click="handleClick(index)"
						:class="{ active: activeIndex === index }">
						<div class="dayDiv">{{ item.name }}</div>
					</li>
				</ul>

				<div class="cloud-Gas-title-content-table">
					<p style="color: #fff;">所在区域</p>
					<p style="color: #fff;">预警类型</p>
					<p style="color: #fff;">预警时间</p>
					<p style="color: #fff;">预警内容</p>
					<p style="color: #fff;">处理措施</p>
					<p style="color: #fff;">查看人</p>
					<p style="color: #fff;">查看状态</p>
				</div>
				<div
					style="width: 100%; height: 20vh; overflow-y: auto; scrollbar-width: thin; scrollbar-color: rgba(150, 150, 150, 0.2) transparent;">
					<div class="cloud-Gas-title-content-table" v-for="(item, index) in WarningListData" :key="index">
						<p>{{ item.tunnelName }}</p>
						<p>{{ item.warningType }}</p>
						<p>{{ item.createTime }}</p>
						<p>{{ item.warningContent }}</p>
						<p>{{ item.remark }}</p>
						<p>{{ item.createBy }}</p>
						<p>{{ item.handleResult }}</p>
					</div>
				</div>

				<div style="margin-top: 1.5vh; padding-top: 1px; ">
					<p
						style="width: 20%; height: 3.5vh; line-height: 3.5vh; float: left; margin-left: 1vw; margin: 0px; padding: 0px; color: rgba(255, 255, 255, 0.6); font-size: 0.8rem;">
						共 {{ total }} 条</p>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page.sync="currentPage" :page-size="100" layout="prev, pager, next, jumper"
						:total="total" style="float: right;">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { lastSevenDayData, getDay, getRandomNumbers } from '@/utils/index.js'
import * as echarts from 'echarts';
import { earlyWarningData, warningList, getWarningStatistics } from '@/public/api.js'

// 引入路由实例
export default {
	name: 'Warning',
	components: {
	},
	data() {
		return {
			TunnelsData: {},
			WarningData: {},
			WarningListData: [],
			warningStatisticsData: [
				{
					"data": [],
					"name": "步距预警",
					"type": 1
				},
				{
					"data": [],
					"name": "人员预警",
					"type": 2
				},
				{
					"data": [],
					"name": "车辆预警",
					"type": 3
				},
				{
					"data": [],
					"name": "气体预警",
					"type": 4
				}],
			myChart1: null,
			activeIndex: 0,
			currentPage: 1,
			total: 0,
			timer: null,
			lastSevenDays: lastSevenDayData(), // 新增最近七天的日期数组
			form: {
				itemId: '',
				date: getDay(), // 结束时间
				type: "gas",
				pageNum: 1, // 页码
				pageSize: 6 // 每页显示条数
			},
			pageSize: 6,
			pageNum: 1,
			lastWarningData: [{
				name: '环境预警',
				value: 'gas'
			},
			{
				name: '人员预警',
				value: 'personnel'
			},
			{
				name: '车辆预警',
				value: 'car'
			},
			{
				name: '步距预警',
				value: 'pace'
			}]
		}
	},
	computed: {

	},
	mounted() {
		let that = this;

		that.TunnelsData = JSON.parse(localStorage.getItem('updateLhTunnels'));
		that.form.itemId = that.TunnelsData.itemId;
		// 初始化图表
		this.myChart1 = echarts.init(document.getElementById('main_Warning'));

		if (window.location.hostname === 'sd.yongsixinxi.com' || window.location.hostname === '127.0.0.1') {
			that.WarningData = {
				car: 10,
				environment: 3,
				worker: 1,
				gas: 20
			}


			const xAxisData = [];
			for (let i = 6; i >= 0; i--) {
				xAxisData.push(this.lastSevenDays[i].startTime);
			}

			const fieldRanges = {
				car: [0, 5],        // 车辆数量：0-5 辆（贴合实际使用场景）
				pace: [0, 3],       // 节奏值：0-3（参考示例中的 0-2 范围，适当扩展）
				gas: [0, 20],       // 油量/燃气量：0-20（参考示例中的 0-15 范围）
				personnel: [0, 8]   // 人员数量：0-8 人（参考示例中的 0-5 范围，适当扩展）
			};

			// 4. 生成最终的随机数据
			const originalData = {};

			// 遍历每个字段（car、pace、gas、personnel）
			Object.keys(fieldRanges).forEach(field => {
				const { min, max } = { min: fieldRanges[field][0], max: fieldRanges[field][1] };
				originalData[field] = {};

				// 为每个日期生成随机值
				xAxisData.forEach(date => {
					originalData[field][date] = getRandomNumbers(min, max);
				});
			});


			this.initChart(this.myChart1, originalData, '#FFB642');

			that.WarningListData = [{
				tunnelName: '进口球机画面1',
				warningType: '步距预警',
				createTime: '2023-10-10 10:00:00',
				warningContent: '步距异常',
				remark: '请检查步距设置',
				createBy: '张三',
				handleResult: '已处理'
			}, {
				tunnelName: '进口球机画面1',
				warningType: '步距预警',
				createTime: '2023-10-10 10:00:00',
				warningContent: '步距异常',
				remark: '请检查步距设置',
				createBy: '黄星',
				handleResult: '已处理'
			}, {
				tunnelName: '进口球机画面1',
				warningType: '步距预警',
				createTime: '2023-10-10 10:00:00',
				warningContent: '步距异常',
				remark: '请检查步距设置',
				createBy: '冯子',
				handleResult: '已处理'
			}]

			that.total = that.WarningListData.length;
		} else {
			that.getearlyWarningData();
			that.getwarningList();
			that.sgetWarningStatistics();

			that.timer = setInterval(() => {
				that.getearlyWarningData();
				that.getwarningList();
				that.sgetWarningStatistics();
			}, 6000)
		}

		// 监听窗口大小变化，自动调整图表
		window.addEventListener('resize', this.handleResize);
	},
	methods: {
		getearlyWarningData() {
			let that = this;
			earlyWarningData({ itemId: that.TunnelsData.itemId }).then(res => {
				if (res.status == 200) {
					that.WarningData = res.data.data;
				} else {
					console.error(res.message);
				}
			})
		},
		getwarningList() {
			let that = this;
			warningList(that.form).then(res => {
				if (res.status == 200) {
					that.WarningListData = res.data.rows;
					that.total = res.data.total;
				} else {
					console.error(res.message);
				}
			})
		},
		sgetWarningStatistics() {
			let that = this;
			getWarningStatistics({ itemId: that.TunnelsData.itemId }).then(res => {
				if (res.status == 200) {
					this.initChart(this.myChart1, res.data.data, '#FFB642');
				} else {
					console.error(res.message);
				}
			})
		},
		handleClick(index) {
			this.activeIndex = index;
			this.form.type = index === 0 ? "gas" : index === 1 ? "personnel" : index === 2 ? "car" : "pace";
			this.getwarningList();
		},
		initChart(myChart, originalData, color) {

			const seriesData = {};

			Object.keys(originalData).forEach(key => {
				seriesData[key] = Object.values(originalData[key]);
			});

			const xAxisData = [];
			for (let i = 6; i >= 0; i--) {
				xAxisData.push(this.lastSevenDays[i].date);
			}
			// 配置项和数据
			var option = {
				tooltip: {
					trigger: 'axis',
					appendToBody: true, // 👈 添加这一行
					backgroundColor: '#333', // 新增：弹窗背景色，解决白字看不清问题
					borderColor: '#666', // 可选：弹窗边框色
					borderRadius: 4, // 可选：弹窗圆角，优化视觉效果
					textStyle: {
						color: 'white' // 已存在：弹窗字体颜色
					}
				},
				legend: {
					data: ['环境预警', '人员预警', '车辆预警', '步距预警'],
					textStyle: {
						color: 'white'
					},
					icon: 'rect', // 使用矩形标记
					itemHeight: 3, // 控制图例标记的高度（单位：px）
					itemWidth: 16, // 控制图例标记的宽度（单位：px），可选，保持与高度一致或按比例设置
					itemGap: 20 // 调整图例项之间的间距，避免拥挤
				},
				toolbox: {
					show: false,
				},
				calculable: true,
				xAxis: [
					{
						type: 'category',
						boundaryGap: false,
						data: xAxisData,
						axisLabel: {
							interval: 0, // 关键：0表示强制显示所有标签（原1可能会间隔显示）
							color: 'white',
							rotate: 0, // 标签旋转30度，避免横向挤压
							margin: 15, // 增加标签与轴线的距离，防止重叠
							fontSize: 9, // 适当减小字体（根据实际情况调整）
							align: 'center' // 标签旋转后居中对齐
						},
					}
				],
				yAxis: [
					{
						type: 'value',
						// 显示Y轴方向的竖线（网格线）
						splitLine: {
							show: true, // 开启竖线
							lineStyle: {
								color: '#f0f0f0',
								width: 0.4,
								type: 'solid'
							}
						},
						// 可选：设置Y轴线本身的样式
						axisLine: {
							show: true,
							lineStyle: {
								color: '#ccc',
								width: 0.3,
								type: 'solid'
							}
						}
					}
				],
				series: [
					{
						name: '环境预警',
						type: 'line',
						stack: '总量',
						data: seriesData.gas,
						lineStyle: {
							color: '#eeaf18' // 深蓝色
						},
						itemStyle: {
							color: '#eeaf18' // 气体图例标记颜色
						}
					},
					{
						name: '人员预警',
						type: 'line',
						stack: '总量',
						data: seriesData.personnel,
						lineStyle: {
							color: '#69D4AA' // 深蓝色
						},
						itemStyle: {
							color: '#69D4AA' // 气体图例标记颜色
						}
					},
					{
						name: '车辆预警',
						type: 'line',
						stack: '总量',
						data: seriesData.car,
						lineStyle: {
							color: '#ec0c26' // 深蓝色
						},
						itemStyle: {
							color: '#ec0c26' // 气体图例标记颜色
						}
					},
					{
						name: '步距预警',
						type: 'line',
						stack: '总量',
						data: seriesData.pace,
						lineStyle: {
							color: '#0caaec' // 深蓝色
						},
						itemStyle: {
							color: '#0caaec' // 气体图例标记颜色
						}
					}
				]
			};

			myChart.setOption(option);
		},
		// 窗口大小变化时调整图表
		handleResize() {
			if (this.myChart1) {
				this.myChart1.resize();
			}
		},
		handleCurrentChange(val) { // 分页
			this.form.pageNum = val + '';
			this.pageNum = val;
			this.getWarningList();
		},
		handleSizeChange(val) { // 分页
			this.form.pageSize = val + '';
			this.pageSize = val;
			this.getWarningList();
		}
	},
	beforeDestroy() {
		// 移除事件监听，销毁图表
		window.removeEventListener('resize', this.handleResize);
		if (this.myChart1) {
			this.myChart1.dispose();
		}
		// 清除定时器
		if (this.timer) {
			clearInterval(this.timer);
		}
	}
}
</script>
<style scoped>
/* 引入字体 */
@font-face {
	font-family: 'DS-Digital';
	src: url('../font/DS-DIGIB.TTF') format('truetype');
	font-weight: normal;
	font-style: normal;
}


.cloud-Warning {
	position: relative;
	top: 5px;
	left: 1%;
	width: 100%;
	height: 100%;
	margin: 0;
	padding: 0;
	box-sizing: border-box;
	/* 新增：确保padding不撑大容器 */

	.cloud-Warning-title {
		position: relative;
		margin-top: 1vh;
		left: 0;
		width: 100%;
		height: calc(445 / 1080 * 100vh);
		background: rgba(0, 0, 0, 0.4);
		border-radius: 10px;
		overflow: hidden;
		/* 新增：禁止子元素超出父容器 */
		box-sizing: border-box;
		/* 新增：确保padding不撑大容器 */

		>.cloud-Warning-title-title {
			position: relative;
			top: 0px;
			left: 0px;
			width: 100%;
			height: 2.5vh;
			margin: 0;
			padding: 0;

			img {
				width: auto;
				height: auto;
				float: left;
				margin: 0;
				padding: 0;
				overflow: hidden;
				/* 新增：禁止子元素超出父容器 */
				box-sizing: border-box;
				/* 新增：确保padding不撑大容器 */
			}

			p {
				position: absolute;
				top: 0.3vh;
				left: 3.01vh;
				width: 100%;
				height: 3vh;
				line-height: 3vh;
				margin: 0;
				padding: 0;
				font-size: 1.0rem;
				color: #fff;
				text-align: left;
				white-space: nowrap;
				/* 关键：禁止文本换行 */
				text-overflow: ellipsis;
				/* 关键：超出部分显示省略号 */
				overflow: hidden;
				/* 关键：配合text-overflow生效 */
				max-width: calc(100% - 4vh);
				/* 新增：限制文本最大宽度，避免超出父容器 */
			}
		}
	}


	.cloud-Warning-title-content-ul {
		list-style: none;
		width: 100%;
		height: 11vh;
		margin: 0;
		padding: 0;
		overflow: hidden;
		/* 新增：禁止子元素超出父容器 */
		box-sizing: border-box;
		/* 新增：确保padding不撑大容器 */

		>li {
			position: relative;
			float: left;
			width: 23%;
			height: 11vh;
			margin: 0;
			padding: 0;
			box-sizing: border-box;
			/* 新增：确保padding不撑大容器 */
			overflow: hidden;
			/* 新增：禁止子元素超出父容器 */

			>img {
				width: 4vw;
				height: auto;
				float: left;
				margin-left: 45%;
				margin-top: 2.0vh;
				border: 1px dashed rgba(227, 225, 225, 0.6);
			}

			>div {
				width: 6vw;
				height: 11vh;
				line-height: 11vh;
				margin: 0px;
				padding: 0px;
				margin-top: 3.0vh;
				margin-left: 1.0vw;
				float: left;
				text-align: left;

				>p {
					width: 100%;
					height: 4vh;
					line-height: 3.5vh;
					margin: 0px;
					padding: 0px;
					color: rgba(227, 225, 225, 0.6);
					font-size: 0.8rem;
				}

				>p:nth-child(1) {
					font-family: DS-Digital, DS-Digital;
					font-weight: 400;
					font-size: 2.2rem !important;
					color: #dfef05;
					font-style: normal;
					text-transform: none;
					margin-right: 0.3vw;
				}


			}
		}

	}

	.cloud-Warning-title-content-table-ul {
		width: 24vw;
		height: 3vh;
		margin: 0;
		padding: 0;
		list-style: none;
		margin-left: 2vw;
		margin-top: 1vh;
		background-color: rgba(255, 255, 255, 0.1);

		>li {
			width: 6vw;
			height: 3vh;
			float: left;
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 0.8rem;
			color: rgba(255, 255, 255, 0.6);
			line-height: 22px;
			text-align: center;
			font-style: normal;
			text-transform: none;
			/* 原有样式保留，新增过渡效果（让阴影变化更丝滑） */
			transition: box-shadow 0.3s ease;

			/* 鼠标移入：添加四周阴影 */
			&:hover {
				box-shadow: 0 0 12px 2px rgba(43, 220, 255, 0.6);
				color: #fff;
				/* 可选：选中时加深边框色，增强视觉区分 */
				/* border-color: #044288; */
				background-color: #044288;
			}

			/* 选中状态：添加更明显的四周阴影（可自定义颜色和强度） */
			&.active {
				box-shadow: 0 0 15px 3px rgba(34, 137, 255, 0.8);
				color: #fff;
				/* 可选：选中时加深边框色，增强视觉区分 */
				/* border-color: #044288; */
				background-color: #044288;
			}

			>div:nth-child(1) {
				/* 原有样式不变 */
			}

			>div:nth-child(2) {
				/* 原有样式不变 */
			}
		}
	}

	.cloud-Gas-title-content-table {
		width: 100%;
		height: 2.5vh;
		margin: 0;
		padding: 0;
		margin-top: 1vh;

		>p {
			height: 2.5vh;
			margin: 0;
			padding: 0;
			float: left;
			line-height: 2.5vh;
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 0.9rem;
			color: rgba(255, 255, 255, 0.6);
			text-align: center;
			font-style: normal;
			text-transform: none;
		}

		>p:nth-child(1) {
			width: 18%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		>p:nth-child(2) {
			width: 13%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		>p:nth-child(3) {
			width: 15%;
		}

		>p:nth-child(4) {
			width: 10%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		>p:nth-child(5) {
			width: 16%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		>p:nth-child(6) {
			width: 16%;
		}

		>p:nth-child(7) {
			width: 5%;
		}

	}


	::v-deep .el-pagination .el-pager li {
		background-color: transparent !important;
		border: 1px solid rgba(255, 255, 255, 0.12);
		color: #409eff !important;
		border-radius: 4px !important;
		margin: 0.2vw;
	}

	::v-deep .el-pagination .btn-prev {
		background-color: transparent !important;
		border: 1px solid rgba(255, 255, 255, 0.12);
		color: #409eff !important;
		height: 25px !important;
		margin-top: 5px;
	}

	::v-deep .el-pagination .btn-next {
		background-color: transparent !important;
		border: 1px solid rgba(255, 255, 255, 0.12);
		color: #409eff !important;
		height: 25px !important;
		margin-top: 5px;
	}

	::v-deep .el-pagination .el-pager li.active {
		background-color: #409eff !important;
		color: #fff !important;
	}

	::v-deep .el-pagination__jump {
		font-size: 0.6rem !important;
		height: 20px !important;
		line-height: 20px !important;
	}

	::v-deep .el-pagination .el-input__inner {
		background-color: transparent !important;
		border: 1px solid rgba(255, 255, 255, 0.12);
	}
}
</style>